import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core'
import { ActivatedRoute, Params } from '@angular/router'
import { IconDefinition } from '@fortawesome/free-regular-svg-icons'

@Component({
  selector: 'app-tabs',
  template: `
    <nav class="tabs-wrapper" [ngClass]="{ 'standalone': standalone }">
      <a #tabRef
         *ngFor="let tab of tabs"
         [routerLink]="tab.disabled ? null : tab.path"
         [relativeTo]="relativeToRoute ? relativeToRoute : route"
         [queryParams]="tab.params"
         [routerLinkActive]="'active'"
         [class]="'tab-item shadow-sm'"
         [ngClass]="{ 'disabled': tab.disabled }"
         [style]="'width: ' + (width !== 'dynamic' ? width : 'auto')"
      >
        <fa-icon *ngIf="tab.icon" [icon]="tab.icon"></fa-icon>
        <span>{{ tab.label | transloco }}</span>
      </a>
    </nav>
  `,
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsComponent implements AfterViewInit {
  @Input() tabs: { path: string; params?: Params, label: string, disabled?: boolean, icon?: IconDefinition }[] = [];
  @Input() shouldRedirectWithQueryParams = true;
  @Input() width: string | 'dynamic' = 'dynamic';
  @Input() standalone = false;
  @Input() relativeToRoute: ActivatedRoute;

  @ViewChildren('tabRef') tabRefs!: QueryList<ElementRef>;

  constructor(protected readonly route: ActivatedRoute) {}

  ngAfterViewInit(): void {
    if (this.width === 'dynamic') {
      this.resetTabsWidth();
      this.updateTabsWidth();
    }
  }

  private resetTabsWidth(): void {
    requestAnimationFrame(() => this.tabRefs.forEach(tab => tab.nativeElement.style.minWidth = ''));
  }

  private updateTabsWidth(): void {
    requestAnimationFrame(() => {
      const maxTabWidth = Math.max(...this.tabRefs.map(el => el.nativeElement.offsetWidth));
      this.tabRefs.forEach(tab => {
        if (tab.nativeElement.offsetWidth < maxTabWidth) {
          tab.nativeElement.style.width = `${maxTabWidth}px`
        }
      })
    });
  }
}
